import davidPic from "@/public/images/artists/david.png";
import { Artist } from "@/types/types";

export const david = {
  id: "237",
  name: "David",
  image: davidPic,
  description: `David's voice has a deep timbre and favors a steady, deliberate cadence. His bars are clearly enunciated, with a slightly dragging drawl that emphasizes rhythm and style over speed. The result is a cool, unhurried delivery that suits rap and drill beats.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdavid-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Unprocessed", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Low",
      },
      specific: {
        low: 45,
        high: 58,
      },
      sweetSpot: 53,
    },
  },
} as const satisfies Artist;
